import React from "react";
import PropTypes from "prop-types";

import { ContainerRow, ContainField } from "../../styles/PageStyles/LegalAndDocumental/OthersFormsStyles";
import { useNavigate } from "react-router-dom";
import { RoutesNames } from "../utils/routes";

const OptionRow = ({ item }) => {
  const navigate = useNavigate();

  const handleGoDetail = () => {
    navigate(RoutesNames.detailOthers, { state: { item } });
  };
  return (
    <ContainerRow onClick={handleGoDetail}>
      <ContainField>{item.firstName}</ContainField>
      <ContainField>{item.lastName}</ContainField>
      <ContainField>{item.state.name}</ContainField>
      <ContainField>{item.cities.name}</ContainField>
    </ContainerRow>
  );
};

OptionRow.propTypes = {
  item: PropTypes.object,
};

export default OptionRow;
